<template>
</template>

<script>
    import InfiniteScroll from "infinite-scroll";
    import $ from "jquery"

    export default {
        props: {},
        data() {
            return {
                infScroll: null
            };
        },
        methods: {
            initInfiniteScroll() {

                this.elem = document.querySelector(".list-actus");

                if ($(".list-actus a").length) {

                    this.infScroll = new InfiniteScroll(this.elem, {
                        append: '.list-actus a',
                        history: false,
                        status: '.page-load-status',
                        path: 'page/{{#}}',
                    });

                    this.infScroll.on( 'error', function( error, path ) {
                        $('.page-load-status').hide()
                    });

                }

            }
        },
        mounted() {
            this.initInfiniteScroll()
        },
        beforeDestroy() {
            this.infScroll.destroy()
        }
    };
</script>
